var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcIngredient(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.3,
    height: 58.3,
    viewBox: "0 0 58.3 58.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Product_library",
    "data-name": "Product library",
    transform: "translate(-577.14 -2118.76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M611.9,2133.58h-6.11v-4.06a10.649,10.649,0,0,0-10.22-10.75c-.14-.01-.27-.01-.4-.01a10.633,10.633,0,0,0-10.62,10.62v4.2h-6.06a1.359,1.359,0,0,0-1.35,1.36v40.7a1.426,1.426,0,0,0,1.42,1.42h19.16a1.714,1.714,0,0,0,.56-1.87,1.352,1.352,0,0,0-1.26-.84H584.05a4.208,4.208,0,0,1-4.2-4.21v-33.85h4.7v2.3a1.406,1.406,0,0,0,1.2,1.4c.05,0,.11.01.16.01a1.359,1.359,0,0,0,1.35-1.36v-2.35h15.82v2.3a1.406,1.406,0,0,0,1.2,1.4c.05,0,.11.01.16.01a1.359,1.359,0,0,0,1.35-1.36v-2.35h4.71v2.36a1.34,1.34,0,0,0,.91,1.28,1.617,1.617,0,0,0,.44.07,1.307,1.307,0,0,0,.95-.4,1.347,1.347,0,0,0,.4-.96v-3.75A1.306,1.306,0,0,0,611.9,2133.58Zm-8.82,0H587.26v-4.09a7.944,7.944,0,0,1,7.53-8.01c.13-.01.26-.01.38-.01a7.921,7.921,0,0,1,7.91,7.91Z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M611.9,2133.58h-6.11v-4.06a10.649,10.649,0,0,0-10.22-10.75c-.14-.01-.27-.01-.4-.01a10.633,10.633,0,0,0-10.62,10.62v4.2h-6.06a1.359,1.359,0,0,0-1.35,1.36v40.7a1.426,1.426,0,0,0,1.42,1.42h19.16a1.714,1.714,0,0,0,.56-1.87,1.352,1.352,0,0,0-1.26-.84H584.05a4.208,4.208,0,0,1-4.2-4.21v-33.85h4.7v2.3a1.406,1.406,0,0,0,1.2,1.4c.05,0,.11.01.16.01a1.359,1.359,0,0,0,1.35-1.36v-2.35h15.82v2.3a1.406,1.406,0,0,0,1.2,1.4c.05,0,.11.01.16.01a1.359,1.359,0,0,0,1.35-1.36v-2.35h4.71v2.36a1.34,1.34,0,0,0,.91,1.28,1.617,1.617,0,0,0,.44.07,1.307,1.307,0,0,0,.95-.4,1.347,1.347,0,0,0,.4-.96v-3.75A1.306,1.306,0,0,0,611.9,2133.58Zm-8.82,0H587.26v-4.09a7.944,7.944,0,0,1,7.53-8.01c.13-.01.26-.01.38-.01a7.921,7.921,0,0,1,7.91,7.91Z",
    fill: "#666"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M634.08,2148.41h-6.15l-.08-.4a8.768,8.768,0,0,0-17.18,0l-.08.4h-6.15a1.359,1.359,0,0,0-1.36,1.35v20.38a6.922,6.922,0,0,0,6.92,6.92h18.53a6.92,6.92,0,0,0,6.91-6.92v-20.38A1.359,1.359,0,0,0,634.08,2148.41Zm-20.57-.67a6.027,6.027,0,0,1,11.38,0l.24.67H613.28Zm19.22,22.4a4.215,4.215,0,0,1-4.2,4.21H610a4.217,4.217,0,0,1-4.21-4.21v-19.03h4.71v2.31a1.387,1.387,0,0,0,1.19,1.39.859.859,0,0,0,.16.01,1.357,1.357,0,0,0,1.35-1.35v-2.36h12.12v2.31a1.387,1.387,0,0,0,1.2,1.39.756.756,0,0,0,.15.01,1.359,1.359,0,0,0,1.36-1.35v-2.36h4.7Z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M634.08,2148.41h-6.15l-.08-.4a8.768,8.768,0,0,0-17.18,0l-.08.4h-6.15a1.359,1.359,0,0,0-1.36,1.35v20.38a6.922,6.922,0,0,0,6.92,6.92h18.53a6.92,6.92,0,0,0,6.91-6.92v-20.38A1.359,1.359,0,0,0,634.08,2148.41Zm-20.57-.67a6.027,6.027,0,0,1,11.38,0l.24.67H613.28Zm19.22,22.4a4.215,4.215,0,0,1-4.2,4.21H610a4.217,4.217,0,0,1-4.21-4.21v-19.03h4.71v2.31a1.387,1.387,0,0,0,1.19,1.39.859.859,0,0,0,.16.01,1.357,1.357,0,0,0,1.35-1.35v-2.36h12.12v2.31a1.387,1.387,0,0,0,1.2,1.39.756.756,0,0,0,.15.01,1.359,1.359,0,0,0,1.36-1.35v-2.36h4.7Z",
    fill: "#666"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIngredient);
export default __webpack_public_path__ + "static/media/ic_ingredient.2d92fd1d.svg";
export { ForwardRef as ReactComponent };